export default {"src":"/_next/static/image/public/images/flags/flag_378.08ee69d5e270e20892c0f0921e69cd6d.svg","height":16,"width":24};